import { useEffect, useState } from "react";
import { GlobalStyle, Container } from "../../common/styles/global-style"
import { DashboardItem, DashboardItems, DrillQuotaLabel } from "./style"
import { Load } from "../../common/load/load";
import { ListDrillsUseCase } from "./application/usecases/actions/list-drills.usecase";
import { Drill } from "./application/domain/drill";
import { urlsPages } from "../../common/urls/urls-pages";
import { DescriptionBody, TitleBody, TopMenu, Wrapper } from "../../common";
import { AuthRepository } from "../../common/auth-guard/auth.repository";
import { DrillSessionQuota, resolveDrillQuota } from "../../common/session-quota/drill-session-quota";

export const DrillsUi = () => {
    const [drills, setDrills] = useState<Drill[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [planDuration, setPlanDuration] = useState<number | undefined>(undefined);
    const [quotaDrills, setQuotaDrills] = useState<DrillSessionQuota[] | undefined>(undefined);

    useEffect(() => {
        let cancelled = false;

        const fetchDrills = async () => {
            setIsLoading(true);
            const [drills, me] = await Promise.all([
                ListDrillsUseCase.execute(),
                AuthRepository.me(),
            ]);
            setIsLoading(false);
            if (!cancelled) {
                setDrills(drills);
                setPlanDuration(me.planDuration);
                setQuotaDrills(me.drills);
            }
        };

        fetchDrills();
        return () => {
            cancelled = true;
        };
    }, []);
    return (
        <>
            <GlobalStyle />
            <TopMenu />
            <Container>
                {isLoading && <Load />}
                <Wrapper>
                    <TitleBody>Drills</TitleBody>
                    <DescriptionBody>Selecione um Drill</DescriptionBody>
                    <DashboardItems>
                        {drills.map((drill) => {
                            const quota = resolveDrillQuota(planDuration, quotaDrills, drill.id);
                            return (
                                <DashboardItem
                                    key={drill.id}
                                    href={urlsPages.workouts.replace(":drillId", drill.id)}
                                    background={drill.img}>
                                    <h1>{drill.name}</h1>
                                    {quota.executionsLimit > 0 && (
                                        <DrillQuotaLabel>
                                            {quota.executionsUsed} de {quota.executionsLimit}
                                        </DrillQuotaLabel>
                                    )}
                                </DashboardItem>
                            );
                        })}
                    </DashboardItems>
                </Wrapper>
            </Container>
        </>
    )
}
